var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconGreyDark = function SvgInfoIconGreyDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4755_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23984 13.7727 1.21446 12.5233 0.608962 11.0615C0.00346057 9.59966 -0.154966 7.99112 0.153716 6.43928C0.462397 4.88743 1.22432 3.46196 2.34314 2.34314C3.46196 1.22432 4.88743 0.462398 6.43928 0.153716C7.99112 -0.154966 9.59966 0.00346104 11.0615 0.608962C12.5233 1.21446 13.7727 2.23984 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 1.33333C6.68146 1.33333 5.39252 1.72432 4.2962 2.45687C3.19987 3.18941 2.34539 4.2306 1.8408 5.44878C1.33622 6.66695 1.20419 8.00739 1.46143 9.3006C1.71866 10.5938 2.3536 11.7817 3.28595 12.714C4.2183 13.6464 5.40619 14.2813 6.6994 14.5386C7.9926 14.7958 9.33305 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31854 14.6667 8C14.6647 6.23248 13.9617 4.53792 12.7119 3.2881C11.4621 2.03828 9.76751 1.33527 8 1.33333Z",
    fill: "#6A6B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33322 12.6669H7.99989V8.0002H6.66656V6.66687H7.99989C8.35351 6.66687 8.69265 6.80735 8.9427 7.05739C9.19275 7.30744 9.33322 7.64658 9.33322 8.0002V12.6669Z",
    fill: "#6A6B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33312C8.55228 5.33312 9 4.88541 9 4.33312C9 3.78084 8.55228 3.33313 8 3.33313C7.44772 3.33313 7 3.78084 7 4.33312C7 4.88541 7.44772 5.33312 8 5.33312Z",
    fill: "#6A6B7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4755_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export default SvgInfoIconGreyDark;